import { initDatePickerTime } from "./helpers/datepicker";
import { getData } from "./helpers/formData";
import { removeErrors } from "./helpers/removeErrors";
import { setErrors } from "./helpers/setErrors";

let body = $('body');
body.find('.select2-select').select2();

const taskCircle = document.querySelector('.tasks__btn');

if(taskCircle) {
    const num = taskCircle.querySelector('[data-count]');
    const count = num.dataset.count;

    if(count > 0) {
        taskCircle.classList.add('puls');
    } else {
        taskCircle.classList.remove('puls');
    }
}

document.body.addEventListener('click', (e) => {
    const taskBtn = document.querySelector('.tasks');
    const btnOpenCreate = e.target.closest('[data-modal="open-modal-task"]');
    const btnCreate = e.target.closest('[data-btn="create-task"]');

    const btnOpenComplete = e.target.closest('[data-btn="open-complete-modal"]');
    const btnOpenExecute = e.target.closest('[data-btn="open-execute-modal"]');
    const btnOpenInspection = e.target.closest('[data-btn="open-inspection-modal"]');
    const btnOpenToWork = e.target.closest('[data-btn="open-to-work-modal"]');
    const btnOpenReturn = e.target.closest('[data-btn="open-return-modal"]');

    const btnConfirmComplete = e.target.closest('[data-btn="confirm-complete-task"]');
    const btnConfirmExecute = e.target.closest('[data-btn="confirm-execute-task"]');
    const btnConfirmInspection = e.target.closest('[data-btn="confirm-inspection-task"]');
    const btnConfirmToWork = e.target.closest('[data-btn="confirm-to-work-task"]');
    const btnConfirmReturn = e.target.closest('[data-btn="confirm-return-task"]');

    const btnCreateComment = e.target.closest('[data-task-btn="create-comment"]');

    if(taskCircle) {
        const num = taskCircle.querySelector('[data-count]');
        const count = num.dataset.count;

        if(taskBtn) {
            if(taskBtn.contains(e.target)) {
                taskBtn.classList.toggle('open');
                if(count > 0) {
                    taskCircle.classList.toggle('puls');
                }
            } else {
                taskBtn.classList.remove('open');
                if(count > 0) {
                    taskCircle.classList.add('puls');
                }
            }
        }
    }

    if(btnOpenCreate) {
        const route = btnOpenCreate.dataset.route;

        removeErrors();
        $.ajax({
            type: "POST",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: route,
            data: {},
            success: function (result) {
                if (result['error'] && result['error'] === 'access-denied') {
                    let modal = body.find('#modal-danger');
                    modal.modal();
                    modal.find('.modal-title').html(result['title']);
                    modal.find('.modal-body').html(result['body']);
                    modal.find('.modal-footer').html(result['footer']);
                } else {
                    let modal = body.find('#modal-full-full');
                    modal.modal();
                    modal.find('.modal-title').html(result['head']);
                    modal.find('.modal-body').html(result['body']);
                    modal.find('.modal-footer').html(result['footer']);
                    modal.find('.modal-content').css({
                        height: '1090px',
                        'max-height': '1200px'
                    });

                    $('.select2-select').select2();
                    initSummernote();

                    initDatePickerTime();
                }
            }
        });
    }

    if(btnCreate) {
    const form = document.getElementById('create-task-modal');
    $('#download').show();
    if (form) {
        removeErrors();

        // видаляємо file-input, який створює summernote
        $(form).find('.note-image-input').remove();

        const route = form.dataset.action;
        const data = getData(form);
        const responsibles = $('#responsibles').val();
        const checkers = $('#checkers').val();

        $.ajax({
            type: "POST",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: route,
            data: { ...data, responsibles, checkers },
                success: function (result) {
                    if (result['error'] && result['error'] === 'access-denied') {
                        let modal = body.find('#modal-danger');
                        modal.modal();
                        modal.find('.modal-title').html(result['title']);
                        modal.find('.modal-body').html(result['body']);
                        modal.find('.modal-footer').html(result['footer']);
                    } else {
                        if(result.status) {
                            body.find('#modal-full-full').modal('hide');
                            addCard(result.content);
                            succesModal();
                        }
                    }
                },
                error: function (error) {
                    setErrors(error);
                }
            });
        }
    }

    if(btnOpenComplete) {
        openModalRes(btnOpenComplete);
    }

    if(btnOpenExecute) {
        openModalRes(btnOpenExecute);
    }

    if(btnOpenInspection) {
        openModalRes(btnOpenInspection);
    }

    if(btnOpenToWork) {
        openModalRes(btnOpenToWork);
    }
    if(btnOpenReturn) {
        openModalRes(btnOpenReturn);
    }

    if(btnConfirmComplete) {
        sendModalForm(btnConfirmComplete, 'complete-task-modal');
    }

    if(btnConfirmExecute) {
        sendModal(btnConfirmExecute);
    }

    if(btnConfirmInspection) {
        sendModal(btnConfirmInspection);
    }

    if(btnConfirmToWork) {
        sendModal(btnConfirmToWork);
    }
    if(btnConfirmReturn) {
        sendModal(btnConfirmReturn);
    }

    if(btnCreateComment) {
        const taskId = btnCreateComment.dataset.taskId;
        const form = document.getElementById('create-task-comment');
        removeErrors();

        if(form) {
            const route = form.dataset.action;
                    $(form).find('.note-image-input').remove();

        const data = getData(form);

        $.ajax({
            type: "POST",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: route,

                data: {...data, taskId: taskId},
                success: function (result) {
                    if (result['error'] && result['error'] === 'access-denied') {
                        let modal = body.find('#modal-danger');
                        modal.modal();
                        modal.find('.modal-title').html(result['title']);
                        modal.find('.modal-body').html(result['body']);
                        modal.find('.modal-footer').html(result['footer']);
                    } else {
                        if(result.status) {
                            const block = document.querySelector('[data-task-comment="comment-block"]');
                            block.innerHTML = result.content;
                            form.reset();
                            $(form).find('.summernote').summernote('code', '');

                        }
                    }
                },
                error: function (error) {
                    setErrors(error);
                }
            });
        }
    }
})

function updateCard(content, id) {
    const cards = document.querySelectorAll('[data-task-card]');

    cards.forEach(card => {
        const cardId = card.dataset.taskCard;
        if(id === Number(cardId)) {
            card.outerHTML = content;
        }
    })
}

function updateContent(content, el) {
    const block = document.querySelector(el);
    if(block) {
        block.outerHTML = content;
    }
}

function addCard(html) {
    const tableBody = document.querySelector('[data-body="task-body"]');

    if(tableBody) {
        tableBody.insertAdjacentHTML('afterbegin', html);
    }
}

function sendModal(btn) {
    const taskId = btn.dataset.taskId;
    const route = btn.dataset.route;
    removeErrors();

    $.ajax({
        type: "POST",
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: route,
        data: {taskId: taskId},
        success: function (result) {
            if (result['error'] && result['error'] === 'access-denied') {
                let modal = body.find('#modal-danger');
                modal.modal();
                modal.find('.modal-title').html(result['title']);
                modal.find('.modal-body').html(result['body']);
                modal.find('.modal-footer').html(result['footer']);
            } else {
                if(result.status) {
                    body.find('#modal-full-full').modal('hide');
                    succesModal();

                    if(result.page === 'index') {
                        updateCard(result.content, result.taskId);
                    }

                    if(result.page === 'show') {
                        updateContent(result.content, '[data-task-content="card-info"]')
                    }
                }
            }
        }
    });
}

function sendModalForm(btn, el) {
    const form = document.getElementById(el);
    const taskId = btn.dataset.taskId;

    if(form) {
        const route = form.dataset.action;
        const data = getData(form);
        removeErrors();

        $.ajax({
            type: "POST",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: route,
            data: {...data, taskId: taskId},
            success: function (result) {
                if (result['error'] && result['error'] === 'access-denied') {
                    let modal = body.find('#modal-danger');
                    modal.modal();
                    modal.find('.modal-title').html(result['title']);
                    modal.find('.modal-body').html(result['body']);
                    modal.find('.modal-footer').html(result['footer']);
                } else {
                    if(result.status) {
                        body.find('#modal-full-full').modal('hide');
                        succesModal();

                        if(result.page === 'index') {
                            updateCard(result.content, result.taskId);
                        }

                        if(result.page === 'show') {
                            updateContent(result.content, '[data-task-content="card-info"]')
                        }
                    }
                }
            },
            error: function (error) {
                setErrors(error);
            }
        });
    }
}

function openModalRes(btn) {
    if(btn) {
        const taskId = btn.dataset.taskId;
        const route = btn.dataset.route;

        $.ajax({
            type: "POST",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: route,
            data: {taskId: taskId},
            success: function (result) {
                if (result['error'] && result['error'] === 'access-denied') {
                    let modal = body.find('#modal-danger');
                    modal.modal();
                    modal.find('.modal-title').html(result['title']);
                    modal.find('.modal-body').html(result['body']);
                    modal.find('.modal-footer').html(result['footer']);
                } else {
                    let modal = body.find('#modal-full-full');
                    modal.modal();
                    if(result.head.length > 0) {
                        modal.find('.modal-header').show();
                        modal.find('.modal-title').html(result['head']);
                    } else {
                        modal.find('.modal-header').hide();
                    }
                    modal.find('.modal-body').html(result['body']);
                    modal.find('.modal-footer').html(result['footer']);
                }
            }
        });
    }
}

function succesModal() {
    let modal = body.find('#access-success')
    modal.modal();
    modal.find('.modal-header').hide();
    modal.find('.modal-body').html(`<div style="font-size: 20px; font-weight: 600; text-align: center;"><b>УСПІШНО</b></div>`);

    let time = 1;
    let timer = setInterval(() => {
        if(time === 0) {
            let modal = body.find('#access-success');
            modal.modal('hide');
            clearInterval(timer);
        }

        --time;
    }, 500);
}

body.on('change', '#status-task, #priority-task, #search, #new_to, #new_from, #in_work_to, #in_work_from, #on_inspection_to, #on_inspection_from, #completed', function () {
    let form = body.find('#filter-form-tasks');
    form.submit();
});

/****** ITEMS PER PAGE ********/
body.on('change', '.items-pre-page', function () {
    let limit = $(this).val();
    let form = body.find('#filter-form-tasks');


    $('<input>').attr({
        type: 'hidden',
        id: 'limit',
        name: 'limit',
        value: limit
    }).appendTo('form');

    form.submit();
});

/****** CHANGE PAGE ********/
body.on('click', '.page-link', function () {
    let page = $(this).data('page');
    let limit = $('#items-per-page-1').val();
    let form = body.find('#filter-form-tasks');

    $('<input>').attr({
        type: 'hidden',
        id: 'page',
        name: 'page',
        value: page
    }).appendTo('form');

    $('<input>').attr({
        type: 'hidden',
        id: 'limit',
        name: 'limit',
        value: limit
    }).appendTo('form');

    form.submit();
});

function initSummernote() {
    const config = {
        height: 500,
        tooltip: false,
        lang: 'uk-UA',
        callbacks: {
            onImageUpload: function (files) {
                const $editor = $(this);

                // Вставляємо картинку як base64 (dataURL),
                // потім бекенд через checkImages збереже у файли
                for (let i = 0; i < files.length; i++) {
                    const reader = new FileReader();
                    reader.onloadend = function () {
                        $editor.summernote('insertImage', reader.result);
                    };
                    reader.readAsDataURL(files[i]);
                }
            }
        }
    };

    $('.summernote').each(function () {
        const $el = $(this);
        if (!$el.data('summernote')) {
            $el.summernote(config);
        }
    });
}

